// #region Imports
import { Fill, Stroke, Style, Text } from 'ol/style.js';
// #endregion
export const styles = {
    line: new Style({
        stroke: new Stroke({ color: 'rgb(125, 0, 0)', width: 1 }),
    }),
    country: {
        base: new Style({
            fill: new Fill({ color: '#f0e6e6' }),
            stroke: new Stroke({ color: '#fff' }),
        }),
        selected: new Style({ fill: new Fill({ color: '#ac1310' }) }),
    },
    label: {
        country: new Style({
            text: new Text({
                font: 'bold 14px sans-serif',
                overflow: true,
                fill: new Fill({ color: '#000' }),
                stroke: new Stroke({ color: '#fff', width: 3 }),
            }),
        }),
        province: new Style({
            text: new Text({
                font: 'bold 14px sans-serif',
                // backgroundFill: new Fill({ color: '#ff0000' }),
                fill: new Fill({ color: '#000' }),
                textBaseline: 'middle',
                textAlign: 'start',
                justify: 'left',
                offsetX: 5,
                // offsetY: 4,
                // stroke: new Stroke({ color: '#fff', width: 3 }),
            }),
        }),
    },
};
